// Post Media Modal
export const UPLOAD_TAB = 'UPLOAD_TAB';
export const FILE_MANAGER_TAB = 'FILE_MANAGER_TAB';

// Posts Queue
export const SCHEDULED_TAB = 'scheduled';
export const PROCESSING_TAB = 'processing';
export const REMOVED_TAB = 'removed';
